<template>
    <div>
        <div class="fd-heading">How do you feel about this page?</div>
        <div class="fd-section">
            <div>Informative content</div>
            <div>
                <star-rating name="fdoption1" :value.sync="rating1"></star-rating>
            </div>
        </div>
        <div class="fd-section">
            <div>Well organized & visually pleasing</div>
            <div>
                <star-rating name="fdoption2" :value.sync="rating2"></star-rating>
            </div>
        </div>
        <div class="fd-section">
            <div>Performance & speed</div>
            <div>
                <star-rating name="fdoption3" :value.sync="rating3"></star-rating>
            </div>
        </div>
        <div class="fd-section">
            <div :class="['form-group', { 'error-field': errors.has('projectId') }]">
                <label>Project ID</label>
                <input class="form-control"
                    placeholder="Enter Project ID"
                    v-model="projectId" name="projectId"
                    v-validate="'digits:10'" maxlength="10"
                    type="text" autocomplete="off"/>
                <span v-show="errors.has('projectId')" class="error-span">
                    {{ getErrorMsg('projectId') }}
                </span>
            </div>
        </div>
        <div class="fd-section">
            <div :class="['form-group', { 'error-field': errors.has('comments') }]">
                <label>Comments</label>
                <textarea class="form-control" style="min-height:150px;"
                    placeholder="Enter your comments here"
                    v-model="comments" name="comments"
                    v-validate="'required'"></textarea>
                <span v-show="errors.has('comments')" class="error-span">
                    {{ getErrorMsg('comments') }}
                </span>
            </div>
        </div>
        <div v-if="!isSave" class="action-btns">
            <button class="btn btn-primary" @click="submitFeedback">Submit</button>
            <button class="btn btn-outline-info" @click="$emit('closePanel')">Close</button>
        </div>
        <div v-else class="action-btns" style="color:#3c7fbb;font-weight:bold;">
            Submitting... please wait.
        </div>
    </div>
</template>

<script>
import validation from '@/mixins/validation'
import StarRating from '../components/StarRating'

export default {
    $_veeValidate: {
        validator: 'new'
    },
    
    components: {
        StarRating
    },
    
    mixins: [validation],
    
    data() {
        return {
            isSave: false,
            rating1: 0,
            rating2: 0,
            rating3: 0,
            projectId: '',
            comments: ''
        }
    },
    
    methods: {
        submitFeedback: function() {
            this.$validator.validateAll().then((result) => {
                if(result) {
                    this.isSave = true
                    this.$api.post('/Common/feedback', this.$data, true, {}, this.$api.CONTENT_TYPE_BODY).done((r) => {
                        this.$emit('closePanel')
                        this.peer.misc.notify('S', 'Thanks for your feedback!', 'Success')
                    }).fail((r) => {
                        this.peer.misc.notify('E', this.$api.getError(r), 'Error Occurred')
                    }).always(() => {
                        this.isSave = false
                    })
                }
            })
        }
    }
}
</script>

<style scoped>
.fd-heading {
    font-size: 18px;
    padding: 15px;
    border-bottom: 1px solid #ccc9c9;
    text-align: center;
    margin: auto 15px;
}
.fd-section {
    padding: 15px 20px 5px 20px;
    border-bottom: 1px dotted #dbd8d8;
    margin: auto 15px;
}
.fd-section > div:first-child {
    font-size: 14px;
}
.fd-section > div:last-child {
    margin-left: -5px;
}
.action-btns {
    padding: 15px 0 20px 30px;
}
.action-btns .btn-outline-info {
    margin-left: 10px;
}
.error-field textarea.form-control {
    border: 1px solid #da1d1d !important;
}
</style>
